import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class LoaderService {
    public subject = new Subject<boolean>();

    constructor() { }

    getLoader(): Observable<any> {
        return this.subject.asObservable();
    }

    show() {
        this.setSubject(true);
    }

    setSubject(value: boolean) {
        this.subject.next(value);
    }

    clear() {
        this.subject.next(null);
    }
}
